export function containsScriptOrSVG(array) {
  let icons = [
    '<svgclass="refresh-icon"id="refresh-icon"viewbox="002424"><pathd="m15,19.88c15.04,20.1814.94,20.514.71,20.71c14.32,21.113.69,21.113.3,20.71l9.29,16.7c9.06,16.478.96,16.169,15.87v10.75l4.21,4.62c3.87,4.193.95,3.564.38,3.22c4.57,3.084.78,35,3v3h19v3c19.22,319.43,3.0819.62,3.22c20.05,3.5620.13,4.1919.79,4.62l15,10.75v19.88m7.04,5l11,10.06v15.58l13,17.58v10.05l16.96,5h7.04z"fill="black"></path></svg>',
    '<svgclass="refresh-icon"id="refresh-icon"viewbox="002424"><pathd="m17.65,6.35c16.2,4.914.21,412,4a8,800,04,12a8,800,012,20c15.73,2018.84,17.4519.73,14h17.65c16.83,16.3314.61,1812,18a6,600,16,12a6,600,112,6c13.66,615.14,6.6916.22,7.78l13,11h20v4l17.65,6.35z"fill="black"></path></svg>',
    '<svgclass="sort-icon"viewbox="002424"><pathd="m13,20h11v8l5.5,13.5l4.08,12.08l12,4.16l19.92,12.08l18.5,13.5l13,8v20z"fill="black"></path></svg>',
    '<svgclass="sort-icon"viewbox="002424"><pathd="m11,4h13v16l18.5,10.5l19.92,11.92l12,19.84l4.08,11.92l5.5,10.5l11,16v4z"fill="black"></path></svg>',
    '<svgclass="sort-icon"viewbox="002424"><pathd="m11,4h13v16l18.5,10.5l19.92,11.92l12,19.84l4.08,11.92l5.5,10.5l11,16v4z"fill="lightgrey"></path></svg>',
    '<svgclass="sort-icon"viewbox="002424"><pathd="m13,20h11v8l5.5,13.5l4.08,12.08l12,4.16l19.92,12.08l18.5,13.5l13,8v20z"fill="lightgrey"></path></svg>',
  ];
  let result = false;
  array.forEach(content=>{
    content = content.replace(/\s+/g, "").toLowerCase();
    icons.forEach((icon) => {
      content = content.replaceAll(icon.replace(/\s+/g, "").toLowerCase(), "");
    });
    if (content.includes("<script") || content.includes("<svg")) result = true;
  })
  return result
}


export function containsBadCharacter(array) {
  const re = new RegExp("(?<![\uD800-\uDBFF])[\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|[\x00-\x08\x0B\x0C\x0E-\x1F\x7F-\x9F\uFEFF\uFFFE\uFFFF]");
  let result = false;
  array.forEach(content=>{
    var execResult = re.exec(content);
    if(execResult !== null) result= true;
  })
 return result;
}